import React from "react";
import { Modal } from "antd";
import Templates from "."

class TemplatesModal extends React.Component {
  render() {
    return (
      (<Modal className='templates-modal' styles={{ body: { maxHeight: 'calc(100vh - 140px)', overflowY: 'auto', overflowX: 'hidden' } }}
        open={this.props.modalType !== null} width='min(820px, calc(100vw - 16px))' {...this.props.modalProps} title={this.props.modalProps.title} centered={true} >
        <Templates isModal={true} selectedTemplates={this.props.modalProps.selectedTemplates} onCancel={this.props.modalProps.onCancel} />
      </Modal>)
    );
  }
}
export default TemplatesModal;